module.exports = __webpack_public_path__ + "static/img/weixin.80344e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/weixin.png
// module id = eRyA
// module chunks = 1